
<template>
  <div>
    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'6-1'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>주문 / 배송 관리 - 주문 현황</p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn02" v-on:click="edit">수정</button>
          </div>
        </div>

        <div class="Admin_PageInner">
          <div class="Admin_PageInfo">
            <p>사용 방법 안내</p>
            <p>1. 결제대기는
              <span style="color: blue;font-weight: bolder;">파란색</span>,
              주문취소요청은
              <span style="color: red;font-weight: bolder;">빨간색</span>,
              결제확인요청은
              <span style="color: green;font-weight: bolder;">초록색</span>으로,
              표시됩니다.</p>
          </div>
          <div ref="table"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import {TabulatorFull as Tabulator} from 'tabulator-tables'
import {
  get_order
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminOrderManagement',
  components: {
    AdminHeader: AdminHeader,
    AdminFooter: AdminFooter
  },
  data () {
    return {
      tabulator: null
    }
  },
  methods: {
    formatCurrency (value) {
      // 쉼표와 '원' 추가
      return value ? value.toLocaleString('ko-KR') + ' 원' : '0 원'
    },
    edit: function () {
      if (this.tabulator.getSelectedData().length > 1) {
        alert('수정할 데이터를 하나만 선택해주세요.')
      } else if (this.tabulator.getSelectedData().length === 0) {
        alert('수정할 데이터를 선택해주세요.')
      } else {
        window.location.href = `
        /AdminOrderManagementAdd?order_ID=${this.tabulator.getSelectedData()[0].order_ID}
        `
      }
    }
  },
  mounted () {
    get_order().then(result_data => {
      this.tabulator = new Tabulator(this.$refs.table, {
        data: result_data,
        layout: 'fitData',
        pagination: 'local', // 로컬 데이터를 기준으로 페이징 처리
        paginationSize: 10, // 한 페이지에 표시할 행 수
        paginationSizeSelector: [5, 10, 20, 50], // 사용자가 선택할 수 있는 페이지 크기 옵션
        columns: [
          {formatter: 'rowSelection',
            titleFormatter: 'rowSelection',
            headerSort: false,
            cellClick: function (e, cell) {
              cell.getRow().toggleSelect()
            }
          },
          {title: '주문번호', field: 'order_ID', headerSort: false},
          {title: '회원ID', field: 'customer_ID_use_order', headerSort: false},
          {title: '받는사람', field: 'order_receive_name', headerSort: false},
          {title: '휴대전화', field: 'order_phone_number', headerSort: false},
          {title: '주문취소요청', field: 'order_cancle_request_status_name', headerSort: false},
          {title: '결제확인요청', field: 'order_check_request_status_name', headerSort: false},
          {title: '이메일', field: 'order_email', headerSort: false},
          {title: '결제여부', field: 'order_pay_status_name', headerSort: false},
          {title: '결제예정금액',
            field: 'order_expected_payment_amount',
            headerSort: false,
            formatter: (cell) => this.formatCurrency(cell.getValue()),
            hozAlign: 'right', // 우측 정렬
            bottomCalc: 'sum', // 합계 계산
            bottomCalcFormatter: (cell) => this.formatCurrency(cell.getValue()) // 합계 포맷
          },
          {title: '결제금액',
            field: 'order_payment_amount',
            headerSort: false,
            formatter: (cell) => this.formatCurrency(cell.getValue()),
            hozAlign: 'right', // 우측 정렬
            bottomCalc: 'sum', // 합계 계산
            bottomCalcFormatter: (cell) => this.formatCurrency(cell.getValue()) // 합계 포맷
          },
          {title: '결제취소금액',
            field: 'order_cancle_amount',
            headerSort: false,
            formatter: (cell) => this.formatCurrency(cell.getValue()),
            hozAlign: 'right', // 우측 정렬
            bottomCalc: 'sum', // 합계 계산
            bottomCalcFormatter: (cell) => this.formatCurrency(cell.getValue()) // 합계 포맷
          },
          {
            title: '결제취소일',
            field: 'order_cancle_date',
            headerSort: false,

            // 결제취소일은 금액이 아니라 날짜 데이터이므로 formatCurrency를 사용하지 않는다.
            // formatCurrency를 사용하면 값 뒤에 '원'이 붙어서 날짜 컬럼이 금액처럼 표시된다.
            formatter: function (cell) {
              const value = cell.getValue()

              // 취소일이 없는 주문은 빈값으로 표시한다.
              if (!value) {
                return ''
              }

              // DB에서 이미 '2026-04-24' 또는 '2026-04-24 13:20:00' 형태로 내려오면
              // 화면에서는 날짜 부분만 보여준다.
              return String(value).substring(0, 10)
            },

            // 날짜는 숫자 합계 대상이 아니므로 우측 정렬보다 가운데 정렬이 자연스럽다.
            hozAlign: 'center'
          },
          {title: '결제방법', field: 'order_method_name', headerSort: false},
          {title: '주문일자', field: 'order_registe', headerSort: false},
          {title: '관리자 메모', field: 'order_memo', headerSort: false}
        ],
        rowFormatter: (row) => {
          const data = row.getData()
          const element = row.getElement()

          if (data.order_pay_status_name === '결제대기') {
            element.style.backgroundColor = 'blue'
            element.style.color = 'white'
          }

          if (data.order_cancle_request_status === 1) {
            element.style.backgroundColor = 'red'
            element.style.color = 'white'
          }

          if (data.order_check_request_status === 1) {
            element.style.backgroundColor = 'green'
            element.style.color = 'white'
          }
        }
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/OrderDeliveryManagement/AdminOrderManagement.vue